import styled from 'styled-components';

import Card from '../../Card';


export const StyledCard = styled(Card)`
  display: grid;
  padding: 20px 40px;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  max-height: 358px;

  h3 {
    font-style: unset;
    font-size: 18px;
    margin-bottom: 10px;
  }

  img {
    max-width: 250px;
    max-height: 250px;
  }
`;

export const Content = styled.div`
  margin: auto 0;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 15px 0 15px 30px;

  p {
    font-size: 22px;
    color: white;
    margin: 0;

    &.yellow {
      color: rgb(181, 249, 45);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/DataCentre/CourseInfo/CourseInfo.styles.ts